import React, { useEffect } from "react";
import DefaultModal from "../DefaultModal/DefaultModal";
import AddBlogForm from "../forms/AddBlogForm/AddBlogForm";
import ModalTitle from "../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
}

const AddBlogModal: React.FC<Props> = (props) => {
  const onApply = () => {
    props.onApply();
    props.onClose();
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.onClose]);

  return (
    <DefaultModal>
      <div className={styles.container}>
        <ModalTitle
          onClose={props.onClose}
          title="Add blog"
          subTitle='Create a new blog post. Fill in the required fields and click "Add blog".'
        />
        <AddBlogForm onApply={onApply} onClose={props.onClose} />
      </div>
    </DefaultModal>
  );
};

export default AddBlogModal;
